const Promise = window.Promise;
const startsWith = String.prototype.startsWith;
const endsWith = String.prototype.endsWith;

export default function () {
	if (Promise) {
		window.Promise = Promise;
	}

	if (startsWith) {
		String.prototype.startsWith = startsWith;
	}

	if (endsWith) {
		String.prototype.endsWith = endsWith;
	}
};


//////////////////
// WEBPACK FOOTER
// ./polyfill.js
// module id = null
// module chunks = 